import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Alert, type AlertProps, Button, Typography } from '@didaskill/ui/design-system';

import messages from './MigratedStatisticsAlert.messages';
import * as styles from './MigratedStatisticsAlert.styles';

type MigratedStatisticsAlertProps = Pick<AlertProps, 'isOpen' | 'onRequestClose'>;

const MigratedStatisticsAlertBase = ({
  isOpen = false,
  onRequestClose,
}: MigratedStatisticsAlertProps) => {
  return (
    <Alert variant="neutral" css={styles.migratedAlert} isOpen={isOpen}>
      <div css={styles.migratedAlertContent}>
        <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>
          <FormattedMessage {...messages.ALERT_CONTENT} />
        </Typography>

        {onRequestClose && (
          <div>
            <Button
              variant={Button.VARIANTS.PRIMARY}
              outline
              size={Button.SIZES.SMALL}
              css={styles.migratedAlertButton}
              onClick={onRequestClose}
            >
              <FormattedMessage {...messages.UNDERSTOOD} />
            </Button>
          </div>
        )}
      </div>
    </Alert>
  );
};

MigratedStatisticsAlertBase.displayName = 'MigratedStatisticsAlert';

export const MigratedStatisticsAlert = memo(MigratedStatisticsAlertBase);
